<div class="row mb-4" *ngFor="let option of options; trackBy:trackByCode; let i = index;">
  <div class="col-6 align-self-center">
    <p class="paragraph">
      {{ option.ov }}
    </p>
  </div>
  <div class="col-6">
    <div class="single-dropdown form-input hide-cross w-100">
      <app-basic-multiselect-select [suggestionValue]="ranks" [selectedItems]="selectedDropdownItems"
        [selectedValues]="selectedDropdownCode[option.code]" [suggestionList]="optionsList" [dropdownSettings]="{
        singleSelection: true,
        enableSearchFilter: false,
        showCheckbox: false,
        classes: '',
        enableCheckAll: false,
        enableFilterSelectAll: false,
        disabled: isViewMode,
        single_select: true,
        enable_search: true,
        position: 'top',
        autoPosition: true,
        tagToBody: false
      }" (emitOnItemSelect)="setDropDownOption(option.code, $event)">
      </app-basic-multiselect-select>
      <ng-template let-selectedCode #selectedDropdownItems>
        <div>
          {{selectedCode.value}}
        </div>
      </ng-template>
      <ng-template let-optionCode #optionsList>
        <div>
          {{optionCode.value}}
        </div>
      </ng-template>
    </div>
  </div>
</div>
